import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { Link } from "../../ui/Link";
import Image from "next/image";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { barlowCondensed } from "../../../utils/fonts";
import { Button } from "../../uiv7/Button";
import type { Route } from "next";
import type { Offer } from "@local/offer/src/types";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { buy } from "@local/i18n/src/catalogs/buy";
import { DiscountPrice } from "./DiscountPrice";
export interface BestSellersSingleBlockProps {
  product: Offer.BlockListing;
  index: number;
  isVisible: boolean;
  vertical?: boolean;
  market?: string;
}
export const BestSellersSingleBlock = t0 => {
  const $ = _c(76);
  const {
    product,
    index,
    isVisible,
    vertical,
    market
  } = t0;
  const productUrl = `/${market}/product/${product.slug}`;
  let T0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== index || $[1] !== isVisible || $[2] !== market || $[3] !== product.image?.filename || $[4] !== product.image?.height || $[5] !== product.image?.url || $[6] !== product.image?.width || $[7] !== product.name || $[8] !== product.prices || $[9] !== productUrl || $[10] !== vertical) {
    const t = getT(getLanguageForMarket(market), {
      buy
    });
    const t14 = index > 2 && !isVisible ? "hidden md:block" : "";
    const t15 = vertical ? "" : "rounded-md shadow-md";
    if ($[25] !== t14 || $[26] !== t15) {
      t13 = cn("group relative h-full w-full", t14, t15);
      $[25] = t14;
      $[26] = t15;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    t11 = "flex h-full w-full flex-col justify-start md:justify-between";
    const t16 = vertical ? "aspect-square" : "aspect-video";
    let t17;
    if ($[28] !== t16) {
      t17 = cn("relative mb-1 w-full overflow-hidden bg-gray-100", t16);
      $[28] = t16;
      $[29] = t17;
    } else {
      t17 = $[29];
    }
    const t18 = product.image?.url as string;
    const t19 = product.image?.width || 640;
    let t20;
    if ($[30] !== t18 || $[31] !== t19) {
      t20 = getCdnUrl({
        src: t18,
        width: t19
      });
      $[30] = t18;
      $[31] = t19;
      $[32] = t20;
    } else {
      t20 = $[32];
    }
    const t21 = product.image?.filename as string;
    const t22 = product.image?.width || 640;
    const t23 = product.image?.height || 640;
    let t24;
    if ($[33] !== t20 || $[34] !== t21 || $[35] !== t22 || $[36] !== t23) {
      t24 = <Image src={t20} alt={t21} width={t22} height={t23} sizes="960px" className="h-full w-full object-cover object-top transition-transform duration-300 ease-in-out group-hover:scale-105 motion-reduce:transition-none" />;
      $[33] = t20;
      $[34] = t21;
      $[35] = t22;
      $[36] = t23;
      $[37] = t24;
    } else {
      t24 = $[37];
    }
    if ($[38] !== t17 || $[39] !== t24) {
      t12 = <div className={t17}>{t24}</div>;
      $[38] = t17;
      $[39] = t24;
      $[40] = t12;
    } else {
      t12 = $[40];
    }
    const t25 = vertical ? "" : "px-6";
    if ($[41] !== t25) {
      t8 = cn(t25, "flex flex-1 flex-col justify-between");
      $[41] = t25;
      $[42] = t8;
    } else {
      t8 = $[42];
    }
    const t26 = vertical ? "" : "text-xl md:text-3xl";
    let t27;
    if ($[43] !== t26) {
      t27 = cn(barlowCondensed.className, "rounded-sm text-xl font-semibold uppercase hover:underline focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 focus-visible:outline-hidden", t26);
      $[43] = t26;
      $[44] = t27;
    } else {
      t27 = $[44];
    }
    let t28;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = <span className="absolute inset-0" aria-hidden="true" />;
      $[45] = t28;
    } else {
      t28 = $[45];
    }
    if ($[46] !== product.name || $[47] !== productUrl || $[48] !== t27) {
      t9 = <h3><Link href={productUrl} className={t27} prefetch={false}>{t28}{product.name}</Link></h3>;
      $[46] = product.name;
      $[47] = productUrl;
      $[48] = t27;
      $[49] = t9;
    } else {
      t9 = $[49];
    }
    if ($[50] !== market || $[51] !== product.prices) {
      t10 = product.prices?.[0] && <DiscountPrice price={product.prices[0]} className="text-sm" market={market} />;
      $[50] = market;
      $[51] = product.prices;
      $[52] = t10;
    } else {
      t10 = $[52];
    }
    T0 = Button;
    t1 = "link";
    t2 = productUrl as Route;
    t3 = false;
    t4 = "true";
    t5 = -1;
    const t29 = vertical ? "mt-2" : "my-4";
    if ($[53] !== t29) {
      t6 = cn("z-raised relative w-full! max-w-full text-lg font-medium uppercase md:font-normal", t29);
      $[53] = t29;
      $[54] = t6;
    } else {
      t6 = $[54];
    }
    t7 = t("buy.shopNow");
    $[0] = index;
    $[1] = isVisible;
    $[2] = market;
    $[3] = product.image?.filename;
    $[4] = product.image?.height;
    $[5] = product.image?.url;
    $[6] = product.image?.width;
    $[7] = product.name;
    $[8] = product.prices;
    $[9] = productUrl;
    $[10] = vertical;
    $[11] = T0;
    $[12] = t1;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    T0 = $[11];
    t1 = $[12];
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t2 = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t14;
  if ($[55] !== T0 || $[56] !== t1 || $[57] !== t2 || $[58] !== t3 || $[59] !== t4 || $[60] !== t5 || $[61] !== t6 || $[62] !== t7) {
    t14 = <T0 as={t1} href={t2} prefetch={t3} aria-hidden={t4} tabIndex={t5} className={t6}>{t7}</T0>;
    $[55] = T0;
    $[56] = t1;
    $[57] = t2;
    $[58] = t3;
    $[59] = t4;
    $[60] = t5;
    $[61] = t6;
    $[62] = t7;
    $[63] = t14;
  } else {
    t14 = $[63];
  }
  let t15;
  if ($[64] !== t10 || $[65] !== t14 || $[66] !== t8 || $[67] !== t9) {
    t15 = <div className={t8}>{t9}{t10}{t14}</div>;
    $[64] = t10;
    $[65] = t14;
    $[66] = t8;
    $[67] = t9;
    $[68] = t15;
  } else {
    t15 = $[68];
  }
  let t16;
  if ($[69] !== t11 || $[70] !== t12 || $[71] !== t15) {
    t16 = <div className={t11}>{t12}{t15}</div>;
    $[69] = t11;
    $[70] = t12;
    $[71] = t15;
    $[72] = t16;
  } else {
    t16 = $[72];
  }
  let t17;
  if ($[73] !== t13 || $[74] !== t16) {
    t17 = <article className={t13}>{t16}</article>;
    $[73] = t13;
    $[74] = t16;
    $[75] = t17;
  } else {
    t17 = $[75];
  }
  return t17;
};